export type Theme =
  | "default"
  | "ocean"
  | "midnight"
  | "rose"
  | "forest"
  | "amber";

export const themes: Record<Theme, { label: string; preview: string }> = {
  default: {
    label: "Default",
    preview: "oklch(0.13 0.00 0)",
  },
  ocean: {
    label: "Ocean",
    preview: "oklch(0.15 0.05 230)",
  },
  midnight: {
    label: "Midnight",
    preview: "oklch(0.13 0.04 280)",
  },

  rose: {
    label: "Rose",
    preview: "oklch(0.13 0.03 10)",
  },
  forest: {
    label: "Forest",
    preview: "oklch(0.13 0.04 145)",
  },
  amber: {
    label: "Amber",
    preview: "oklch(0.13 0.03 60)",
  },
};
